import './intro.css';
import { TextModal } from '../TextModal/TextModal';
import { useEffect, useState } from 'react';
import knowMoreData from './know-more.data.json';
import { useGoogleTagManager } from '@tracktor/react-google-tag-manager';

interface IntroProps {
    onStartButton: () => void;
}

interface KnowMoreData {
    title: string;
    description: string;
}

const data = knowMoreData as KnowMoreData;

export function Intro({ onStartButton }: IntroProps) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { sendEvent } = useGoogleTagManager();
    useEffect(() => {
        setIsModalVisible(false);
    }, []);

    const onKnowMoreClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        sendEvent({
          event: "gtm.linkClick",
          linkData: {
            targetUrl: "",
            elementId: "intro-know-more-button",
            elementClasses: ["learn-more-link"],
            elementTarget: "modal",
          },
        });
        setIsModalVisible(true);
    }

    return (
      <div className="intro-container">
        <div className="intro-content">
          <h1 className="intro-title">
            AF-Screen
          </h1>

          <p className="intro-description">
            O AF-Screen é um instrumento clínico de triagem simplificada,
            destinado a médicos, com o propósito de{" "}
            <b>
              aumentar a suspeita de Ataxia de Friedreich (AF)
            </b>{" "}
            e outras ataxias hereditárias, especialmente em locais onde não há especialistas em neurologia.
          </p>

          <p className="intro-description">
            Baseado nos domínios mais sensíveis das escalas mFARS, ICARS e SARA, o formulário avalia 5 domínios clínicos, 
            por meio de 8 itens binários (“Presente”/“Ausente”). A pontuação total (0 a 8) orienta a conduta sugerida, 
            como investigação, encaminhamento neurológico ou indicação de teste genético.{" "}
            <b>O preenchimento estimado dura menos de três minutos e não há necessidade de exames complementares para aplicação</b>. 
            O AF-Screen deve ser aplicado em pacientes que apresentem:
            <ul className="intro-description-list">
              <li><b>Ataxia progressiva </b>(dificuldade de coordenação que piora com o tempo);</li>
              <li><b>Desequilíbrio com instabilidade ao caminhar </b>(marcha);</li>
              <li><b>Problemas na fala </b>(disartria); e/ou</li>
              <li><b>Perda de reflexos </b>(arreflexia).</li>
            </ul>
          </p>

          <p className="intro-description">
            Se os sintomas forem de início agudo, considere causas como AVC de circulação posterior ou infecções do sistema nervoso central. Caso não sejam agudos, prossiga com a avaliação estruturada.
          </p>

          <div className="intro-warning">
            <h3 className="warning-title">
              Este instrumento é apenas uma ferramenta de triagem clínica.
            </h3>
            <p className="warning-text">
              Não possui validação psicométrica formal e <b>não substitui</b> o exame neurológico completo, 
              testes genéticos ou exames complementares. Os resultados devem ser interpretados à luz da história clínica,
              progressão dos sintomas e avaliação física detalhada.{" "}
              <b>A decisão diagnóstica e terapêutica final é de responsabilidade do médico assistente</b>.<br />
              <button
                onClick={onKnowMoreClick}
                id="intro-know-more-button"
                className="learn-more-link"
              >
                Saiba mais sobre o AF-Screen
              </button>
            </p>
          </div>

        </div>
        <div className="intro-actions">
          <button
            className="start-button"
            data-name="biogen_start"
            type="submit"
            onClick={onStartButton}
          >
            Iniciar
          </button>
        </div>
        <TextModal
          title={data.title}
          description={data.description}
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
        />
      </div>
    );
}